import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { injectIntl } from 'react-intl';
import utils from '../../utils/utils';
import DATE_FORMAT from '../../components/constants/dateFormat';

const AdminSubscriptionRow = ({ subscription }) => {
  return (
    <tr>
      <th scope="row">
        <div>
          <Link to={`/admin/subscriptions/${subscription.id}`} className="link">
            S{subscription.id}
          </Link>
        </div>

        <div className="text-muted">
          <small>
            <a
              className={'link'}
              target="_blank"
              href={`https://dashboard.stripe.com/subscriptions/${subscription.stripeSubscriptionId}`}
            >
              Stripe
            </a>
          </small>
        </div>
      </th>
      <td>
        <div>
          {subscription.address.customerName} - {subscription.address.phoneNumber}
        </div>
        <div className="text-muted">
          <small>
            By:{' '}
            <Link className="link" to={`/admin/users/${subscription.user.id}`}>
              #{subscription.user.id} {subscription.user.screenName}
            </Link>
          </small>
        </div>
        <div className="text-muted">
          <small>Email: {subscription.address.email}</small>
        </div>
        <div className="text-muted">
          <small>
            <div>{subscription.address.street}</div>
          </small>
        </div>
        <div className="text-muted">
          <small>
            {utils.getFormattedDateFromString(subscription.dateCreated, DATE_FORMAT.displayWithTimeAndWeekday)}
          </small>
        </div>
        {subscription.cancelDate ? (
          <div className="text-muted">
            <small>
              Cancelled:{' '}
              {utils.getFormattedDateFromString(subscription.cancelDate, DATE_FORMAT.displayWithTimeAndWeekday)}
            </small>
          </div>
        ) : (
          ''
        )}
      </td>
      <td className={subscription.archived ? 'text-muted' : ''}>
        <div>
          {subscription.active ? '✅' : '❌'} {subscription.stripeStatus}
        </div>
        <div>{subscription.archived ? '🗑️ Archived' : ''}</div>
      </td>
      <td>
        <div>{subscription.frequency || '-'}</div>
        <div>
          {subscription.deliveryDay} {subscription.timeRange}
        </div>
        <div>
          Next delivery:{' '}
          {utils.getFormattedDateFromString(subscription.nextDeliveryDate, DATE_FORMAT.displayWeekdayAndDate)}
        </div>
      </td>
      <td>
        <ul>
          {subscription.items.map((item) => (
            <li>
              {item.quantity > 1 ? <strong>{`${item.quantity} x `}</strong> : ''}
              {`${item.itemName} (${item.itemPrice}€)`}
            </li>
          ))}
        </ul>
      </td>
      <td>
        <Link to={`/admin/subscriptions/edit/${subscription.id}`} className="btn btn-normal-link" onClick={() => {}}>
          Edit
        </Link>
        <br />
      </td>
    </tr>
  );
};

AdminSubscriptionRow.propTypes = {
  subscription: PropTypes.object.isRequired,
};

AdminSubscriptionRow.defaultProps = {};

export default injectIntl(AdminSubscriptionRow);
